import { PartialTenantCustomizations } from "src/tenantCustomizations/TenantCustomizations.ts";
import { getSalvosTaskContextMenuComponents } from "src/tenantCustomizations/tenants/salvos/GetSalvosTaskContextMenuComponents.tsx";

export const salvosCustomizations: PartialTenantCustomizations = {
	tenantConfig: {
		erp: {
			enabled: true,
			ledgerIntegrationEnabled: true,
		},
		maps: {
			enabled: true,
		},
	},
	taskContextMenuComponents: ({ task }) => getSalvosTaskContextMenuComponents(task),
};
